<template>
  <div class="type_manage" >
    <el-divider content-position="left">核定税种列表</el-divider>
    <el-row style="margin-bottom: .4rem">
      <el-col>
        <el-button type="primary" size="small" @click="handleAddOpenTaxCategory">新增</el-button>
        <el-button type="primary" size="small" @click.native="$router.push('setting_panel')">返回上一级</el-button>
      </el-col>
    </el-row>
    <el-table :data="pageDataTaxCategory" size="medium" style="width: 100%">
      <el-table-column label='税种id'>
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label='税种名称'>
        <template slot-scope="scope">
          {{ scope.row.tax_name }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEditTaxCategory(scope.$index, scope.row)">
            编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--    页码-->
    <el-pagination background class="tr mt-10" layout="total, prev, pager, next, jumper" :hide-on-single-page="false"
      :current-page="pageOptionTaxCategory.currentPage" :page-sizes="[10, 20]"
      :page-size="pageOptionTaxCategory.pageSize" :total="pageOptionTaxCategory.total"
      @size-change="handleSizeChangeTaxCategory" @current-change="handleCurrentChangeTaxCategory">
    </el-pagination>
    <!--    添加-->
    <el-drawer title="添加" :visible.sync="AddDrawerTaxCategory" :direction="direction" :before-close="handleClose"
      size="40%">
      <div class="m-tabs-content">
        <el-row>
          <el-col :span="6" class="m-label">税种名称</el-col>
          <el-col :span="10">
            <el-input placeholder="请输入税种名称" :size="inputSize" v-model="addDataTaxCategory.tax_name" clearable>
            </el-input>
          </el-col>
        </el-row>
        <div class="addCon">
          <el-button type="primary" size="mini" @click="handleAddTaxCategroy">添加</el-button>
        </div>
      </div>
    </el-drawer>
    <!--    编辑-->
    <el-drawer title="编辑" :visible.sync="saveDrawerTaxCategory" :direction="direction"
      :before-close="handleSaveDrawerClose" size="40%">
      <div class="m-tabs-content">
        <el-row>
          <el-col :span="6" class="m-label">税种名称</el-col>
          <el-col :span="10">
            <el-input placeholder="请输入税种名称" :size="inputSize" v-model="saveDataTaxCategory.tax_name" clearable>
            </el-input>
          </el-col>
        </el-row>
      </div>
      <div class="addCon">
        <el-button type="primary" size="mini" @click="handleSaveTaxCategory">保存</el-button>
      </div>
    </el-drawer>

  </div>
</template>
<script>
export default {
  name: 'type_manage',
  data () {
    return {

      inputSize: 'small',
      activeName: 'ten',
      optionAccountArea: [],
      optionCompanyScale: [],
      optionTaxCategory: [],
      optionBussinessContent: [],
      pageOptionAccountArea: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      pageOptionCompanyScale: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      pageOptionTaxCategory: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      pageOptionBussinessContent: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      AddDrawerAccountArea: false,
      saveDrawerAccountArea: false,
      AddDrawerCompanyScale: false,
      saveDrawerCompanyScale: false,
      AddDrawerTaxCategory: false,
      saveDrawerTaxCategory: false,
      AddDrawerBussinessContent: false,
      saveDrawerBussinessContent: false,
      direction: 'rtl',
      addDataAccountArea: {
        id: '',
        area_name: ''
      },
      saveDataAccountArea: {
        id: '',
        area_name: '',
        index: null
      },
      addDataCompanyScale: {
        id: '',
        scale_name: ''
      },
      saveDataCompanyScale: {
        id: '',
        scale_name: '',
        index: null
      },
      addDataTaxCategory: {
        id: '',
        tax_name: ''
      },
      saveDataTaxCategory: {
        id: '',
        tax_name: '',
        index: null
      },
      addDataBussinessContent: {
        id: '',
        bussin_name: ''
      },
      saveDataBussinessContent: {
        id: '',
        bussin_name: '',
        index: null
      },
      addTaxBureauDrawer: false,
      saveTaxBureauDrawer: false,
      pids: [],
      taxBureau: [],
      addDataTaxBureau: {
        pid: null,
        tax_name: '',
        phone: ''
      },
      saveDataTaxBureau: {
        index: null,
        id: null,
        pid: null,
        tax_name: '',
        phone: '',
        son: []
      },
      pageOptionTaxBureau: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      addMarketBureauDrawer: false,
      saveMarketBureauDrawer: false,
      marketpids: [],
      MarketBureau: [],
      addDataMarketBureau: {
        pid: null,
        market_name: '',
        phone: ''
      },
      saveDataMarketBureau: {
        index: null,
        id: null,
        pid: null,
        market_name: '',
        phone: '',
        son: []
      },
      pageOptionMarketBureau: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      complaints: [],
      addComplaintDrawer: false,
      pageOptionComplaint: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      addDataComplaint: {
        reason: ''
      },
      upDataComplaint: {
        index: null,
        id: null,
        reason: ''
      },
      upComplaintDrawer: false
    }
  },
  computed: {
    pageDataAccountArea: {
      get: function () {
        return this.optionAccountArea.slice(this.pageOptionAccountArea.pageSize * (this.pageOptionAccountArea.currentPage - 1), this.pageOptionAccountArea.pageSize * this.pageOptionAccountArea.currentPage)
      }
    },
    pageDataCompanyScale: {
      get: function () {
        return this.optionCompanyScale.slice(this.pageOptionCompanyScale.pageSize * (this.pageOptionCompanyScale.currentPage - 1), this.pageOptionCompanyScale.pageSize * this.pageOptionCompanyScale.currentPage)
      }
    },
    pageDataTaxCategory: {
      get: function () {
        return this.optionTaxCategory.slice(this.pageOptionTaxCategory.pageSize * (this.pageOptionTaxCategory.currentPage - 1), this.pageOptionTaxCategory.pageSize * this.pageOptionTaxCategory.currentPage)
      }
    },
    pageDataBussinessContent: {
      get: function () {
        return this.optionBussinessContent.slice(this.pageOptionBussinessContent.pageSize * (this.pageOptionBussinessContent.currentPage - 1), this.pageOptionBussinessContent.pageSize * this.pageOptionBussinessContent.currentPage)
      }
    },
    pageDataTaxBureau: {
      get: function () {
        return this.taxBureau.slice(this.pageOptionTaxBureau.pageSize * (this.pageOptionTaxBureau.currentPage - 1), this.pageOptionTaxBureau.pageSize * this.pageOptionTaxBureau.currentPage)
      }
    },
    pageDataMarketBureau: {
      get: function () {
        return this.MarketBureau.slice(this.pageOptionMarketBureau.pageSize * (this.pageOptionMarketBureau.currentPage - 1), this.pageOptionMarketBureau.pageSize * this.pageOptionMarketBureau.currentPage)
      }
    },    
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {
    handleClick (tab, event) {
      // console.log(tab, event)
    },
    // 所属区域
    getDataAccountArea () {
      this.$axios.get('/api/account_area')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionAccountArea = data.data
            this.pageOptionAccountArea.total = this.optionAccountArea.length
          }
        })
    },
    handleAddOpenAccountArea () {
      this.AddDrawerAccountArea = true
    },
    handleAddAccountArea () {
      if (!this.addDataAccountArea.area_name) {
        this.$message.error('区域名称不能为空')
        return
      }
      this.$axios.post('/api/account_area', { area_name: this.addDataAccountArea.area_name })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionAccountArea.unshift(data.data)
            this.pageOptionAccountArea.total = this.optionAccountArea.length
            this.$message.success(data.msg)
            this.clearAddData()
            this.AddDrawerAccountArea = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleEditAccountArea (index, row) {
      this.saveDataAccountArea.area_name = row.area_name
      this.saveDataAccountArea.id = row.id
      this.saveDataAccountArea.index = index
      this.saveDrawerAccountArea = true
    },
    handleSaveAccountArea () {
      if (!this.saveDataAccountArea.area_name) {
        this.$message.error('原因不能为空')
        return
      }
      this.$axios.patch('/api/account_area/' + this.saveDataAccountArea.id, { area_name: this.saveDataAccountArea.area_name }
      ).then((res) => {
        const { data } = res
        if (data.code === 0) {
          let index = this.pageOptionAccountArea.pageSize * (this.pageOptionAccountArea.currentPage - 1) + this.saveDataAccountArea.index
          this.optionAccountArea[index].area_name = this.saveDataAccountArea.area_name
          this.$message.success(data.msg)
          this.clearSaveData()
          this.saveDrawerAccountArea = false
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    handleSizeChangeAccountArea (val) {
      this.pageOptionAccountArea.pageSize = val
    },
    handleCurrentChangeAccountArea (val) {
      this.pageOptionAccountArea.currentPage = val
    },
    // 公司规模
    getDataCompanyScale () {
      this.$axios.get('/api/company_scale')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionCompanyScale = data.data
            this.pageOptionCompanyScale.total = this.optionCompanyScale.length
          }
        })
    },
    handleAddOpenCompanyScale () {
      this.AddDrawerCompanyScale = true
    },
    handleAddCompanyScale () {
      if (!this.addDataCompanyScale.scale_name) {
        this.$message.error('区域名称不能为空')
        return
      }
      this.$axios.post('/api/company_scale', { scale_name: this.addDataCompanyScale.scale_name })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionCompanyScale.unshift(data.data)
            this.pageOptionCompanyScale.total = this.optionCompanyScale.length
            this.$message.success(data.msg)
            this.clearAddData()
            this.AddDrawerCompanyScale = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleEditCompanyScale (index, row) {
      this.saveDataCompanyScale.scale_name = row.scale_name
      this.saveDataCompanyScale.id = row.id
      this.saveDataCompanyScale.index = index
      this.saveDrawerCompanyScale = true
    },
    handleSaveCompanyScale () {
      if (!this.saveDataCompanyScale.scale_name) {
        this.$message.error('原因不能为空')
        return
      }
      this.$axios.patch('/api/company_scale/' + this.saveDataCompanyScale.id, { scale_name: this.saveDataCompanyScale.scale_name }
      ).then((res) => {
        const { data } = res
        if (data.code === 0) {
          let index = this.pageOptionCompanyScale.pageSize * (this.pageOptionCompanyScale.currentPage - 1) + this.saveDataCompanyScale.index
          this.optionCompanyScale[index].scale_name = this.saveDataCompanyScale.scale_name
          this.$message.success(data.msg)
          this.clearSaveData()
          this.saveDrawerCompanyScale = false
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    handleSizeChangeCompanyScale (val) {
      this.pageOptionCompanyScale.pageSize = val
    },
    handleCurrentChangeCompanyScale (val) {
      this.pageOptionCompanyScale.currentPage = val
    },
    // 核定税种
    getDataTaxCategory () {
      this.$axios.get('/api/tax_category')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionTaxCategory = data.data
            this.pageOptionTaxCategory.total = this.optionTaxCategory.length
          }
        })
    },
    handleAddOpenTaxCategory () {
      this.AddDrawerTaxCategory = true
    },
    handleAddTaxCategroy () {
      if (!this.addDataTaxCategory.tax_name) {
        this.$message.error('区域名称不能为空')
        return
      }
      this.$axios.post('/api/tax_category', { tax_name: this.addDataTaxCategory.tax_name })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionTaxCategory.unshift(data.data)
            this.pageOptionTaxCategory.total = this.optionTaxCategory.length
            this.$message.success(data.msg)
            this.clearAddData()
            this.AddDrawerTaxCategory = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleEditTaxCategory (index, row) {
      this.saveDataTaxCategory.tax_name = row.tax_name
      this.saveDataTaxCategory.id = row.id
      this.saveDataTaxCategory.index = index
      this.saveDrawerTaxCategory = true
    },
    handleSaveTaxCategory () {
      if (!this.saveDataTaxCategory.tax_name) {
        this.$message.error('税种名称不能为空')
        return
      }
      this.$axios.patch('/api/tax_category/' + this.saveDataTaxCategory.id, { tax_name: this.saveDataTaxCategory.tax_name }
      ).then((res) => {
        const { data } = res
        if (data.code === 0) {
          let index = this.pageOptionTaxCategory.pageSize * (this.pageOptionTaxCategory.currentPage - 1) + this.saveDataTaxCategory.index
          this.optionTaxCategory[index].tax_name = this.saveDataTaxCategory.tax_name
          this.$message.success(data.msg)
          this.clearSaveData()
          this.saveDrawerTaxCategory = false
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    handleSizeChangeTaxCategory (val) {
      this.pageOptionTaxCategory.pageSize = val
    },
    handleCurrentChangeTaxCategory (val) {
      this.pageOptionTaxCategory.currentPage = val
    },
    // 商机内容
    getDataBussinessContent () {
      this.$axios.get('/api/bussin_content')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionBussinessContent = data.data
            this.pageOptionBussinessContent.total = this.optionBussinessContent.length
          }
        })
    },
    handleAddBussinessContent () {
      if (!this.addDataBussinessContent.bussin_name) {
        this.$message.error('区域名称不能为空')
        return
      }
      this.$axios.post('/api/bussin_content', { bussin_name: this.addDataBussinessContent.bussin_name })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionBussinessContent.unshift(data.data)
            this.pageOptionBussinessContent.total = this.optionBussinessContent.length
            this.$message.success(data.msg)
            this.clearAddData()
            this.AddDrawerBussinessContent = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleEditBussinessContent (index, row) {
      this.saveDataBussinessContent.bussin_name = row.bussin_name
      this.saveDataBussinessContent.id = row.id
      this.saveDataBussinessContent.index = index
      this.saveDrawerBussinessContent = true
    },
    handleAddOpenBussinessContent () {
      this.AddDrawerBussinessContent = true
    },
    handleSaveBussinessContent () {
      if (!this.saveDataBussinessContent.bussin_name) {
        this.$message.error('商机内容不能为空')
        return
      }
      this.$axios.patch('/api/bussin_content/' + this.saveDataBussinessContent.id, { bussin_name: this.saveDataBussinessContent.bussin_name }
      ).then((res) => {
        const { data } = res
        if (data.code === 0) {
          let index = this.pageOptionBussinessContent.pageSize * (this.pageOptionBussinessContent.currentPage - 1) + this.saveDataBussinessContent.index
          this.optionBussinessContent[index].bussin_name = this.saveDataBussinessContent.bussin_name
          this.$message.success(data.msg)
          this.clearSaveData()
          this.saveDrawerBussinessContent = false
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    handleSizeChangeBussinessContent (val) {
      this.pageOptionBussinessContent.pageSize = val
    },
    handleCurrentChangeBussinessContent (val) {
      this.pageOptionBussinessContent.currentPage = val
    },
    handleSaveDrawerClose (done) {
      this.$confirm('确认关闭?')
        .then(_ => {
          this.clearSaveData()
          done()
        })
        .catch(_ => {
        })
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {
        })
    },
    clearAddData () {
      this.addDataAccountArea.area_name = ''
      this.addDataCompanyScale.scale_name = ''
      this.addDataTaxCategory.tax_name = ''
      this.addDataBussinessContent.bussin_name = ''
    },
    clearSaveData () {
      this.saveDataAccountArea.area_name = ''
      this.saveDataCompanyScale.scale_name = ''
      this.saveDataTaxCategory.tax_name = ''
      this.saveDataBussinessContent.bussin_name = ''
    },
    // 所属税务局
    getDataTaxBureau () {
      this.$axios.get('/api/tax_bureau')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.taxBureau = data.data.list
            this.pids = data.data.pids
            this.pids.unshift({ id: 0, tax_name: '添加税务局' })
            this.pageOptionTaxBureau.total = data.data.list.length
          }
        })
    },
    handleSizeChangeTaxBureau (val) {
      this.pageOptionTaxBureau.pageSize = val
    },
    handleCurrentChangeTaxBureau (val) {
      this.pageOptionTaxBureau.currentPage = val
    },
    handleAddOpenTaxBureau () {
      this.addTaxBureauDrawer = true
    },
    handleAddTaxBureau () {
      if (this.addDataTaxBureau.pid === null) {
        this.$message.error('请选择税务局')
        return false
      }
      if (!this.addDataTaxBureau.tax_name) {
        this.$message.error('请填写名称')
        return false
      }
      if (this.addDataTaxBureau.pid > 0 && !this.addDataTaxBureau.phone) {
        this.$message.error('请填写专管员电话')
        return false
      }
      this.$axios.post('/api/tax_bureau', this.addDataTaxBureau)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.handleCloseTaxBureau()
            this.getDataTaxBureau()
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleEditTaxBureau (index, row) {
      this.saveDataTaxBureau.index = index
      this.saveDataTaxBureau.id = row.id
      this.saveDataTaxBureau.pid = row.pid
      this.saveDataTaxBureau.tax_name = row.tax_name
      this.saveDataTaxBureau.phone = row.phone
      this.saveDataTaxBureau.son = row.son
      this.saveTaxBureauDrawer = true
    },
    handleSaveTaxBureau (item) {
      if (item.pid === null) {
        this.$message.error('请选择税务局')
        return false
      }
      if (!item.tax_name) {
        this.$message.error('请填写名称')
        return false
      }
      if (item.pid > 0 && !item.phone) {
        this.$message.error('请填写专管员电话')
        return false
      }
      this.$axios.post('/api/tax_bureau/' + item.id, item)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.handleCloseTaxBureau()
            this.getDataTaxBureau()
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleDeleteTaxStaff (id, pid) {
      this.$axios.post('/api/tax_bureau/' + id + '/' + pid)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.handleCloseTaxBureau()
            this.getDataTaxBureau()
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleCloseTaxBureau () {
      this.addTaxBureauDrawer = false
      this.saveTaxBureauDrawer = false
      this.addDataTaxBureau.pid = null
      this.addDataTaxBureau.tax_name = ''
      this.addDataTaxBureau.phone = ''
      this.saveDataTaxBureau.pid = null
      this.saveDataTaxBureau.tax_name = ''
      this.saveDataTaxBureau.phone = ''
      this.saveDataTaxBureau.index = null
      this.saveDataTaxBureau.son = []
    },
    // 所属市场局
    getDataMarketBureau () {
      this.$axios.get('/api/market_bureau')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.MarketBureau = data.data.list
            this.marketpids = data.data.pids
            this.marketpids.unshift({ id: 0, market_name: '添加市场局' })
            this.pageOptionMarketBureau.total = data.data.list.length
          }
        })
    },
    handleSizeChangeMarketBureau (val) {
      this.pageOptionMarketBureau.pageSize = val
    },
    handleCurrentChangeMarketBureau (val) {
      this.pageOptionMarketBureau.currentPage = val
    },
    handleAddOpenMarketBureau () {
      this.addMarketBureauDrawer = true
    },
    handleAddMarketBureau () {
      if (this.addDataMarketBureau.pid === null) {
        this.$message.error('请选择市场局')
        return false
      }
      if (!this.addDataMarketBureau.market_name) {
        this.$message.error('请填写名称')
        return false
      }
      if (this.addDataMarketBureau.pid > 0 && !this.addDataMarketBureau.phone) {
        this.$message.error('请填写专管员电话')
        return false
      }
      this.$axios.post('/api/market_bureau', this.addDataMarketBureau)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.handleCloseMarketBureau()
            this.getDataMarketBureau()
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleEditMarketBureau (index, row) {
      this.saveDataMarketBureau.index = index
      this.saveDataMarketBureau.id = row.id
      this.saveDataMarketBureau.pid = row.pid
      this.saveDataMarketBureau.market_name = row.market_name
      this.saveDataMarketBureau.phone = row.phone
      this.saveDataMarketBureau.son = row.son
      this.saveMarketBureauDrawer = true
    },
    handleSaveMarketBureau (item) {
      if (item.pid === null) {
        this.$message.error('请选择市场局')
        return false
      }
      if (!item.market_name) {
        this.$message.error('请填写名称')
        return false
      }
      if (item.pid > 0 && !item.phone) {
        this.$message.error('请填写专管员电话')
        return false
      }
      this.$axios.post('/api/market_bureau/' + item.id, item)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.handleCloseMarketBureau()
            this.getDataMarketBureau()
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleDeleteMarketStaff (id, pid) {
      this.$axios.post('/api/market_bureau/' + id + '/' + pid)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.handleCloseMarketBureau()
            this.getDataMarketBureau()
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleCloseMarketBureau () {
      this.addMarketBureauDrawer = false
      this.saveMarketBureauDrawer = false
      this.addDataMarketBureau.pid = null
      this.addDataMarketBureau.market_name = ''
      this.addDataMarketBureau.phone = ''
      this.saveDataMarketBureau.pid = null
      this.saveDataMarketBureau.market_name = ''
      this.saveDataMarketBureau.phone = ''
      this.saveDataMarketBureau.index = null
      this.saveDataMarketBureau.son = []
    },
    // 投诉原因
    getComplaints () {
      this.$axios.get('/api/admin/complaints')
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.complaints = data.data.data
            this.pageOptionComplaint.total = data.data.total
          }
        })
    },
    handleSizeChangeComplaint (val) {
      this.pageOptionComplaint.pageSize = val
    },
    handleCurrentChangeComplaint (val) {
      this.pageOptionComplaint.currentPage = val
    },
    handleAddOpenComplaint () {
      this.addComplaintDrawer = true
    },
    handleCloseAddComplaint (done) {
      this.addDataComplaint.reason = ''
      done()
    },
    handleAddComplaint () {
      console.log(this.addDataComplaint)
      if (!this.addDataComplaint.reason) {
        this.$message.error('请输入投诉原因')
        return
      }

      this.$axios.post('/api/admin/complaints', this.addDataComplaint)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.addDataComplaint.reason = ''
            this.addComplaintDrawer = false
            this.pageOptionComplaint.currentPage = 1
            this.getComplaints()
            this.$message.success(data.msg)
          }
        })
    },
    handleEditComplaint (index, row) {
      this.upDataComplaint.index = index
      this.upDataComplaint.id = row.id
      this.upDataComplaint.reason = row.reason
      this.upComplaintDrawer = true
    },
    handleSaveComplaint () {
      if (!this.upDataComplaint.reason) {
        this.$message.error('投诉原因不能为空')
        return
      }

      this.$axios.post('/api/admin/complaints/' + this.upDataComplaint.id, this.upDataComplaint)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.complaints[this.upDataComplaint.index].reason = this.upDataComplaint.reason
            this.clearUpDataComplaint()
            this.upComplaintDrawer = false
            this.$message.success(data.msg)
          }
        })
    },
    clearUpDataComplaint () {
      this.upDataComplaint.index = null
      this.upDataComplaint.id = null
      this.upDataComplaint.reason = ''
    },
    handleCloseUpComplaint (done) {
      this.clearUpDataComplaint()
      done()
    }
  },
  mounted () {
    // this.getDataAccountArea()
    // this.getDataCompanyScale()
    this.getDataTaxCategory()
    // this.getDataBussinessContent()
    // this.getDataTaxBureau()
    // this.getDataMarketBureau()
    // this.getComplaints()
  }
}
</script>

<style scoped lang="stylus">
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  @import '~styles/icon.styl'
  .el-drawer__wrapper >>> .el-drawer
    overflow-y: auto
  .el-drawer__wrapper >>> .el-drawer__header span
    color: #4c87fc
    font-size 0.36rem
    font-weight 400
  .type_manage
    marginLeft()
  .mt-10
    margin-top: .2rem
  .tr
    text-align: right
  .m-tabs-content
    padding: 0 .2rem 0 .4rem
    overflow-y auto
    .m-label
      line-height: .64rem
    .el-row
      margin-bottom: .4rem
    .el-date-editor.el-input, .el-date-editor.el-input__inner
      width: 100%
    .el-select
      width: 100%
  .type_manage >>> .el-table__header th
    color: #333333
    background-color: #ECF4FF
  .addCon
    padding: .2rem
    text-align: right
  .count_style
    display: inline-block
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
</style>



// WEBPACK FOOTER //
// src/pages/setting_panel/HdtaxCateList.vue